import React from 'react';
import UpdateStaffingNoteForm from 'domain/staffing/dashboard/dashboard/shared/staffingContent/notes/UpdateStaffingNoteForm';
import useStaffingNotesService from 'domain/staffing/dashboard/dashboard/shared/staffingContent/notes/staffingNotesService';
import { FormFieldsData } from 'framework/form';

interface StaffingNoteTimelineUpdateFormProps {
  messageContext: string;
  entityId?: string;
  afterSubmit?: { execute?: (id: any, data: any) => void };
  getDataFunc: () => Promise<any>;
  onCancel: () => void;
}

const StaffingNoteTimelineUpdateForm = ({
  entityId,
  afterSubmit,
  getDataFunc,
  onCancel,
  ...rest
}: StaffingNoteTimelineUpdateFormProps) => {
  const { updateStaffingNote } = useStaffingNotesService();

  const updateFormFunc = async (id: string, values: FormFieldsData): Promise<object> => {
    const data = await updateStaffingNote(id, {
      noteText: values.noteText,
      attachmentPaths: values.attachmentPaths || [],
    });
    afterSubmit?.execute?.(id, data);
    return data;
  };

  if (!entityId) return null;

  return (
    <UpdateStaffingNoteForm
      id={entityId}
      updateFormFunc={updateFormFunc}
      getDataFunc={getDataFunc}
      onCancel={onCancel}
      afterSubmit={{ message: 'Note has been updated successfully' }}
      {...rest}
    />
  );
};

export default StaffingNoteTimelineUpdateForm;
